import { Dashboard } from "../dashboard/dashboard";

export function MonthlyStatistics({
  selectedMonthLabel,
}: {
  selectedMonthLabel: any;
}) {
  const selectedMonth = selectedMonthLabel.split(" ")[0];
  const selectedYear = new Date().getFullYear();
  
  // Convert month name to numeric value for Dashboard
  const monthNameToValue = {
    "January": 1,
    "February": 2, 
    "March": 3,
    "April": 4,
    "May": 5,
    "June": 6,
    "July": 7,
    "August": 8,
    "September": 9,
    "October": 10,
    "November": 11,
    "December": 12
  };
  
  // Get numeric month value
  const selectedMonthValue = monthNameToValue[selectedMonth] ?? 0;
  
  return (
    <div>
      <h2 className="text-xl font-semibold text-foreground mb-4">
        Monthly Statistics - {selectedMonthLabel}
      </h2>
      <Dashboard selectedYear={selectedYear} selectedMonthLabel={selectedMonthValue} />
    </div>
  );
}